interface MicrosoftIconProps {
  size?: number;
  className?: string;
}

/**
 * Logo oficial Microsoft (4 quadrados). Cores fixas conforme brand guidelines —
 * não substituir por currentColor.
 */
export function MicrosoftIcon({ size = 18, className }: MicrosoftIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 23 23"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
    >
      <title>Microsoft</title>
      <rect x="1" y="1" width="10" height="10" fill="#F25022" />
      <rect x="12" y="1" width="10" height="10" fill="#7FBA00" />
      <rect x="1" y="12" width="10" height="10" fill="#00A4EF" />
      <rect x="12" y="12" width="10" height="10" fill="#FFB900" />
    </svg>
  );
}
